import styled from 'styled-components';
import {FormGroup} from '../../../ui-toolkit/indexExportV2';
import DetailBlock from './DetailBlock';
import DetailCategory from './DetailCategory';

export const DetailGrid = styled.div`
    ${DetailBlock} {
        ${DetailCategory.Wrapper} {
            > ${FormGroup}:last-of-type > div > div > div > div {
                padding-bottom: 0px;
            }

            ${DetailBlock} {
                padding-top: 4px;
                padding-bottom: 0px;
                margin-bottom: 0px;
                ${DetailCategory.Wrapper} {
                    padding-bottom: 20px;
                    margin-bottom: 0px;

                    ${DetailBlock} {
                        padding-top: 0px;
                        padding-bottom: 0px;
                        margin-bottom: 0px;

                        ${DetailCategory.Wrapper} {
                            padding-bottom: 0;
                            margin-bottom: 0px;
                            ${FormGroup} {
                                margin-bottom: 1px;
                            }
                        }
                    }

                    ${FormGroup} {
                        > div > div > ${FormGroup} {
                            margin-bottom: 12px;
                            &:last-of-type {
                                margin-bottom: 28px;
                            }
                        }
                    }
                }
            }
        }
    }
`;
